var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import AccountPage from '../../pages/AccountPage';
import CtaButton from '../../components/CtaButton';
import ShippingAddressList from './partials/ShippingAddressList';
import ContentLoader from '../../components/ContentLoader';
import { localizeUrl } from '../../core/helpers/url-helper';
import { fetchShippingAddresses } from '../ShippingAddress/store/actions';
import { updateUser } from '../Auth/store/actions';
var mapStateToProps = function (state) { return ({
    auth: state.auth,
    collection: state.shippingAddress.collection,
}); };
var mapDispatchToProps = {
    fetchShippingAddresses: fetchShippingAddresses,
    updateUser: updateUser,
};
var connector = connect(mapStateToProps, mapDispatchToProps);
var ShippingAddresses = /** @class */ (function (_super) {
    __extends(ShippingAddresses, _super);
    function ShippingAddresses() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ShippingAddresses.prototype.componentDidMount = function () {
        this.initializeComponent();
    };
    ShippingAddresses.prototype.render = function () {
        var _this = this;
        var _a;
        if ('loaded' !== this.props.collection.status) {
            return React.createElement(ContentLoader, null);
        }
        return (React.createElement(AccountPage, { title: "account.addresses.title" },
            React.createElement("div", null,
                React.createElement(ShippingAddressList, { defaultShippingAddressId: (_a = this.props.auth.item.item) === null || _a === void 0 ? void 0 : _a.default_shipping_address_id, items: this.props.collection.items, updateHandler: function (data) { return _this.handleUpdate(data); } }),
                React.createElement("div", { className: "h-padding-top--30" },
                    React.createElement(CtaButton, { link: localizeUrl('/shipping-addresses/create'), icon: "add", label: "shipping_address.list.add_button.title", modifier: ['pink-100', 'icon-right', 'wide', 'xs-full'] })))));
    };
    ShippingAddresses.prototype.handleUpdate = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.props.updateUser(data)
                        // TODO: error handling
                    ];
                    case 1:
                        response = _a.sent();
                        // TODO: error handling
                        if (!response) {
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ShippingAddresses.prototype.initializeComponent = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.props.fetchShippingAddresses();
                return [2 /*return*/];
            });
        });
    };
    return ShippingAddresses;
}(React.Component));
export default connector(withTranslation()(ShippingAddresses));
